import { useFiling } from "../../../../contexts/FilingContext";
import { Table } from "../../../../design/table";
import FileListItem from "../../../FileListPage/FileListItem";
import FilingListItem from "../../../FilingListPage/FilingListItem";

const FilingDetailExhibitList: React.FC = () => {
  const { filing, setFiling } = useFiling();
  return (
    <Table>
      {filing?.exhibits.map((exhibit) => (
        <FileListItem key={exhibit._id} file={exhibit} />
      ))}
    </Table>
  );
};

export default FilingDetailExhibitList;
